var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.868 5.50703L27.743 13.382C27.9125 13.5516 28 13.7758 28 13.9508C28 14.1258 27.9146 14.3986 27.7436 14.5693L19.8686 22.4443C19.5268 22.7861 18.9728 22.7861 18.6316 22.4443C18.2903 22.1025 18.2898 21.5485 18.6316 21.2073L25.0136 14.8252H0.875C0.391344 14.8252 0 14.4339 0 13.9995C0 13.5158 0.391344 13.1245 0.875 13.1245H25.0141L18.632 6.74242C18.2902 6.40063 18.2902 5.84664 18.632 5.50539C18.9738 5.16414 19.5289 5.16469 19.868 5.50703Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftGray);
export default __webpack_public_path__ + "static/media/arrow_left_gray.4e078db580833a6bc99bc986aad650c3.svg";
export { ForwardRef as ReactComponent };